import type { MerchantPartnerAgreementOrderType } from '../model';

export const confirmationKeys = {
  all: () => ['merchant-confirmation'] as const,
  order: (
    applicationId: string | undefined,
    type: MerchantPartnerAgreementOrderType
  ) => [...confirmationKeys.all(), 'order', applicationId, type] as const,
};
